<template>
  <section>
    <!-- Main navbar -->
    <top-menu 
      @showMenu="showLeftMenu()"
      @hideMenu="hideLeftMenu()"
    />

    <!-- Page content -->
    <div class="page-content">
      <!-- Main sidebar -->
      <left-menu />
      <div class="content-wrapper overflow-y-auto">
        <header-content />
        <!-- page content -->
        <div class="content mb-4">
          <slot />
        </div>
        <!-- /page content -->
      </div>
    </div>
  </section>
</template>

<script>
import TopMenu from "./template/TopMenu";
import LeftMenu from "./template/LeftMenu";
import HeaderContent from "./template/HeaderContent";
import FooterContent from "./template/FooterContent";
import { mapGetters } from "vuex";
import { IS_LOGGED_IN, USER } from "../../vuex-store/types";

export default {
  components: {
    TopMenu,
    LeftMenu,
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      hoverLogo: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: IS_LOGGED_IN,
      user: USER,
    }),
  },

  watch: {
    isLoggedIn(isLoggedIn) {
      if (!isLoggedIn) {
        this.$router.push("/login");
      }
    },
  },

  methods: {
    showLeftMenu() {
      this.hoverLogo = true
    },
    hideLeftMenu() {
      this.hoverLogo = false
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/web/SocialLayout.vue